import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from "src/app/modules/auth/services/auth.service";
import { TokenStorageService } from "./token-storage-service";

const TOKEN_HEADER_KEY = 'Authorization';      

@Injectable({
    providedIn: 'root',
})

export class HttpInterceptorService implements HttpInterceptor {

    constructor(private authService: AuthService,
        private token: TokenStorageService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req;
        const token = this.token.getToken();
        if (token != null) {
            authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
        }
        return next.handle(authReq);
    }

}
